<template>
  <svg width="40" height="29" viewBox="0 0 40 29" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M33.5625 12.7031C37.25 13.4531 40 16.7031 40 20.5156C40 24.9531 36.375 28.5156 32 28.5156H9C4 28.5156 0 24.5156 0 19.5156C0 15.6406 2.5 12.2656 6 11.0781C6 10.8906 6 10.7031 6 10.5156C6 5.01562 10.4375 0.515625 16 0.515625C19.6875 0.515625 22.9375 2.57812 24.625 5.57812C25.5625 4.89062 26.75 4.51562 28 4.51562C31.3125 4.51562 34 7.20312 34 10.5156C34 11.3281 33.8125 12.0156 33.5625 12.7031ZM24.5625 16.5156C25.4375 16.5156 25.875 15.4531 25.25 14.8281L18.6875 8.26562C18.3125 7.89062 17.625 7.89062 17.25 8.26562L10.6875 14.8281C10.0625 15.4531 10.5 16.5156 11.375 16.5156H15.5V23.5156C15.5 24.0781 15.9375 24.5156 16.5 24.5156H19.5C20 24.5156 20.5 24.0781 20.5 23.5156V16.5156H24.5625Z" :fill="props.fill"/>
</svg>

</template>

<script setup>
import { defineProps } from 'vue';
const props = defineProps({
  fill: {
    type: String,
    default: '#000000',
  },
});
</script>
